import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

/**
 * 定义 Footer 组件
 */
class HotBrand extends React.PureComponent {
    static propTypes = {
        brandData: PropTypes.arrya,
    };

    /**
     * 渲染组件
     */
    render() {
        const { brandData } = this.props;
        const junmpUrl = location.href.includes('172.30.')
            ? 'http://172.30.21.20:3000/pc/auto/brand/'
            : 'http://auto.ifeng.com/brand/';

        return (
            <div className={styles.hotBrand}>
                <div className={styles.hotBrandHead}>热门品牌</div>
                <Chip id="260827" type="struct" title="汽车导航" groupName="导航栏">
                    <div className={styles.hotBrandContent}>
                        {brandData.map((item, index) => {
                            return (
                                <div key={index} className={styles.hotBrandItem}>
                                    <a href={`${junmpUrl}${item.url}?brandId=${index}`} target="_blank">
                                        <img className={styles.hotBrandItemIcon} src={item.pic} />
                                        <div className={styles.hotBrandItemText}>{item.name}</div>
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(HotBrand);
